// extracted by mini-css-extract-plugin
module.exports = {"priceList":"list-module--priceList--25YbS","testimonialsList":"list-module--testimonialsList--1JRPh"};